<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field v-model="view_record.search_value" label="Search ..." append-icon="fas fa-search" outlined style="margin: 0 0 -30px 0;"></v-text-field>
      </v-col>
      <v-col md="12">
        <v-card elevation="4">
          <v-card-title>
            View Import Record
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table :headers="view_record.import_record_headers" :items="import_record_items" :items-per-page="5" class="elevation-1">
              <template v-slot:item.last_open_date="{ item }">
                {{new Date(item.last_open_date).getFullYear() + '-' + (new Date(item.last_open_date).getMonth() + 1) + '-' + new Date(item.last_open_date).getDate()}}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'view_import_record',
  data: () => ({
    view_record: {}
  }),
  created () {
    this.asyn_data()
    this.view_record = this.$store.state.viewRecord
    this.view_record.asyn_data = this.asyn_data
  },
  computed: {
    import_record_items () {
      return this.view_record.items.filter(item =>
        item.open_id.includes(this.view_record.search_value) ||
        item.FamilyGTLCode.toString().includes(this.view_record.search_value) ||
        item.MemberGTLCode.toString().includes(this.view_record.search_value) ||
        item.AgentGTLCode.toString().includes(this.view_record.search_value) ||
        item.display_name.includes(this.view_record.search_value) ||
        item.MemberEmailID.includes(this.view_record.search_value) ||
        item.total_report.toString().includes(this.view_record.search_value) ||
        item.counter.toString().includes(this.view_record.search_value) ||
        item.last_open_date.toString().includes(this.view_record.search_value) ||
        this.view_record.search_value === ''
      )
    }
  },
  methods: {
    asyn_data () {
      this.$apis.readImportRecords().then(res => {
        let result = []
        res.data.data.forEach(item => {
          result.push({
            display_name: item.display_name,
            open_id: item.open_id,
            MemberGTLCode: item.MemberGTLCode,
            FamilyGTLCode: item.FamilyGTLCode,
            AgentGTLCode: item.AgentGTLCode,
            MemberEmailID: item.MemberEmailID,
            total_report: item.total_report,
            counter: item.counter,
            last_open_date: item.last_open_date
          })
        })
        this.$store.commit('setViewRecordItem', result)
      })
    }
  }
}
</script>
